import { render } from "./base_Input.vue?vue&type=template&id=fbceac1e"
import script from "./base_Input.vue?vue&type=script&lang=js"
export * from "./base_Input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__